import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";

const authAtom = atomWithStorage("auth", {
  user: null,
});

const authLoadingAtom = atom(true);

const useAuthStore = () => {
  const [auth, setAuth] = useAtom(authAtom);
  const [loading, setAuthLoading] = useAtom(authLoadingAtom);

  const setUser = (user) => {
    setAuth({
      user,
    });
  };

  const clearUser = () => {
    setAuth({
      user: null,
    });
  };

  const setLoading = (value) => {
    setAuthLoading(value);
  };

  return {
    user: auth.user,
    loading,
    setUser,
    clearUser,
    setLoading,
  };
};

export default useAuthStore;